import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Canal de déploiement : lab | internal | stable (V14.73)
// Les flags résolus arrivent du backend. Fail-open : un flag inconnu ou un
// contexte pas encore chargé rend la feature VISIBLE (évite de casser l'UX
// en preview / pendant le chargement).
const ChannelContext = createContext({ channel: 'internal', flags: null, isEnabled: () => true });

export const ChannelProvider = ({ children }) => {
  const { user } = useAuth();
  const [state, setState] = useState({ channel: 'internal', flags: null });

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    axios.get(`${API}/env/channel`, { withCredentials: true })
      .then(r => { if (!cancelled) setState({ channel: r.data.channel, flags: r.data.flags || {} }); })
      .catch(() => { /* fail-open */ });
    return () => { cancelled = true; };
  }, [user]);

  const isEnabled = (key) => {
    if (!state.flags) return true;
    if (!(key in state.flags)) return true;
    return !!state.flags[key];
  };

  return (
    <ChannelContext.Provider value={{ channel: state.channel, flags: state.flags, isEnabled }}>
      {children}
    </ChannelContext.Provider>
  );
};

export const useChannel = () => useContext(ChannelContext);
